import { skipToken, useQuery } from "@tanstack/react-query";
import { trpc, useTRPC } from "../../../shared/api/trpc";

// The other side of a typed relation: who points at this item, and what the
// relation is called from here. Derived from the same values that store the
// forward direction, so it is always in step with them.
export type InboundRelationGroup = Awaited<ReturnType<typeof trpc.workObjects.inboundRelations.query>>[number];

export function useInboundRelations(workObjectId: string | null) {
  const trpc = useTRPC();
  const query = useQuery(trpc.workObjects.inboundRelations.queryOptions(workObjectId ? { workObjectId } : skipToken));

  return {
    data: query.data ?? [],
    isLoading: query.isPending,
  };
}
